<div class="db-hosting-domains-manage-dns" [ngClass]="{'website_copied': websiteCopied, 'page_scrolled': isScrolled}">
  <div class="db-hosting-domains-manage-dns-header" *ngIf="!insideTab">
    <div class="route-container">
      <span class="mr6" [routerLink]="['../../']">Domains</span>
      <i class="db-icon db-icon-ds-arrow-right"></i>
      <div class="domain-name">
        <i class="db-icon db-icon-ds-globus"></i>
        <span>{{this.zone?.zone?.name}}</span>
      </div>
    </div>
  </div>
  <div class="db-hosting-body-wrap" [ngClass]="{'isScrolled': isScrolled, 'inside-tab':!insideTab}">
    <div class="record-actions">
      <div class="record-actions-description">
        <div class="description-header">{{ 'text_DNSRecords' | dbText }}</div>
        <div class="description-text">{{'text_DNSRecordsTranslateDomain' | dbText}}</div>
      </div>
      <ds-dropdown
        [smallSize]="true"
        [dsDropdownWithArrowIcon]="true"
        [dsDropdownOptions]="domainOptions"
        [showDropDown]="false"
        [darkMode]="true"
        [dsDropdownPlaceHolder]="'text_addDnsRecord' | dbText"
        [keepPlaceholder]=true
        [color]="'black'"
        [dsDropdownWidth]="'180px'"
        [dsDropdownListMaxHeight]="'110px'"
        (onOptionChoose)="addRecord(null, $event)"
      ></ds-dropdown>
    </div>
    <div *ngIf="zone && zone.records && zone.records.length" class="add-record-item-wrap__records">
      <db-manage-dns-list (confirmRemove)="confirmRemove($event)"
                          [zone]="zone"
                          (addRecord)="addRecord($event)">
      </db-manage-dns-list>
    </div>
    <div class="db-remove-zone-wrap" *ngIf="isExternal && !insideTab">
      <div class="db-remove-zone-info">
        <div class="db-remove-zone-info-title">{{'text_deleteZoneTitle' | dbText}}</div>
        <div class="db-remove-zone-info-desc" [innerHTML]="'text_deleteZoneDesc' | dbText"></div>
      </div>
      <div class="db-remove-zone-action">
        <a (click)="confirmRemoveDomain()" class="ds-btn ds-btn-red"
           [ngClass]="{'db-button_disabled': removeLoading}">
          <span *ngIf="!removeLoading">{{'text_deleteZoneTitle' | dbText}}</span>
          <db-loading-circular-spinner *ngIf="removeLoading"></db-loading-circular-spinner>
        </a>
      </div>
    </div>
  </div>
</div>
